/**
* Created By: Jennifer Mancilla
* Creation Date: 08/09/2022
* PBI: 78282 - Landing Bienvenida Cotizador Bepensa
*
* Last Modifier:
* Last Modification: 
*
* Feat: 
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { validateSteps } from '../../../interfaces/commonInterfaces';

const initialState: validateSteps = {
    validateFirstStep: false,
    validateSecondStep: false,
    validateManualForm: false,
    validatethirdStep: false,
    validateFourStep: false,
    validateFifthStep: false,
};

export const ValidatesSlice = createSlice({
    name: 'Validates',
    initialState,
    reducers: {
        setValidateFirstStep: (state: validateSteps, action: PayloadAction<boolean>) => { state.validateFirstStep = action.payload },
        setValidateSecondStep: (state: validateSteps, action: PayloadAction<boolean>) => { state.validateSecondStep = action.payload },
        setValidateManualForm: (state: validateSteps, action: PayloadAction<boolean>) => { state.validateManualForm = action.payload},
        setValidateThirdStep: (state: validateSteps, action: PayloadAction<boolean>) => { state.validatethirdStep = action.payload },
        setValidateFourStep: (state: validateSteps, action: PayloadAction<boolean>) => { state.validateFourStep = action.payload },
        setValidateFifthStep: (state: validateSteps, action: PayloadAction<boolean>) => { state.validateFifthStep = action.payload },
    },
});

export const {
    setValidateFirstStep,
    setValidateSecondStep,
    setValidateManualForm,
    setValidateThirdStep,
    setValidateFourStep,
    setValidateFifthStep,
} = ValidatesSlice.actions;